import { Moment } from 'moment';

export class SowsAssessment {
  name = "";
  score = "";

  constructor(name = "", score = "") {
    this.name = name;
    this.score = score;
  }
}

export class DoseTime {
  name = "";
  time = "";
  doseNumber?: number;
  dosageResponseId?: number;

  constructor(name = "", time = "", doseNumber?: number, dosageResponseId?: number) {
    this.name = name;
    this.time = time;
    this.doseNumber = doseNumber;
    this.dosageResponseId = dosageResponseId;
  }
}

export class WatchWorn {
  am: number[] = [];
  pm: number[] = [];

  constructor(length = 12, initialValue = 0) {
    this.am = Array(length).fill(initialValue);
    this.pm = Array(length).fill(initialValue);
  }
}

export class WatchCharging {
  am: WatchChargingItem[] = [];
  pm: WatchChargingItem[] = [];

  constructor(length = 12) {
    const createArray = () => Array.from({ length }, () => ({ value: 0, active: false }));
    this.am = createArray();
    this.pm = createArray();
  }
}

export class BiometricCollectionCount {
  am: number[] = [];
  pm: number[] = [];

  constructor(length = 12, initialValue = 0) {
    this.am = Array(length).fill(initialValue);
    this.pm = Array(length).fill(initialValue);
  }
}

export class UpsertDosageResponse {
  clientId = 0;
  dosageResponseId?: number;
  syncDate = "";
  dosageDate?: string;
  participantId = 0;
  doseNumber = 0;
}

export class UpsertAppointmentStatus
{
    clientId = 0;
    id?: number;
    appointmentDate = "";
    participantId = 0;
    rescheduled = false;
    noShow = false;
}

export class ParticipantPayment {
  dosageUnits = 0;
  dosageTotal = 0.00;
  sowsUnits = 0;
  sowsTotal = 0.00;
  watchWornUnits = 0;
  watchWornTotal = 0.00;
  watchChargingUnits = 0;
  watchChargingTotal = 0.00; 
  totalPayment = 0.00;
}

export class ResearchRewards {
  action = "";
  quantity?: number;
  rate?: number;
  total = 0.00;
}

export class UpsertPaymentHistory {
  clientId = 0;
  participantId = 0;
  targetDate = "";
  paid = false;
  paidBy = "";
}

export class PaymentStatus {
  paid = false;
}

export class AppointmentStatus {
  id?: number;
  noShow = false;
  utoxTaken = false;
}

export class AssessmentSummary {
  createdTime = "";
  assessmentTime = "";
  totalScore = 0;
}

class WatchChargingItem {
  value = 0;
  active = false;
}

export function createSowsAssessments(count = 3) {
  return Array.from({ length: count }, (_, index) => 
    new SowsAssessment(`SOWS Assessment #${index + 1}`, "")
  );
}

export function createDoseTimes(count = 2) {
  return Array.from({ length: count }, (_, index) => 
    new DoseTime(`Dose #${index + 1}`, "")
  );
}

export class AlertZone {
  color = "";
  startZone = 0;
  endZone = 0;
}

export interface DateTimePickerChangeEvent {
  date:    Moment | false;
  oldDate: Moment | false;
}